import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input"]

  toggle() {
    this.inputTarget.checked = !this.inputTarget.checked
  }
}
